export default __webpack_public_path__ + "static/media/38k.fdf53e03.yaml";